<template>
    <div id="contactUs" class="contactUs-padding">
        <div class="row">
            <div class="col-12 col-sm-12 col-md-7">
                <div class="breadcrumbs">
                    <p :lang=selectedLanguageCode>{{ $t('message.you-are-here') }}</p>
                    <ul>
                        <li>
                            <router-link tag="a" to="/">{{ $t('message.LEXIN') }}</router-link>
                        </li>
                        <li>
                            <font-awesome-icon icon="arrow-right" class="right-agap"/>
                            <span>{{ $t('message.privacy-statement') }}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <Language></Language>
        </div>
        <div class="row">
            <div class="col-12">
                <h1>
                    <span>{{ $t('message.privacy-statement-full') }}</span>
                </h1>
                <div class="clearfix"></div>
                <div class="home-info inner-info">
                    <h2>{{ $t('message.privacy-1') }}</h2>
                    <p>{{ $t('message.privacy-2') }}</p>
                    <br>
                    <h2>{{ $t('message.privacy-3') }}</h2>
                    <p>{{ $t('message.privacy-4') }}</p>

                    <br>
                    <h2>{{ $t('message.privacy-5') }}</h2>
                    <p>{{ $t('message.privacy-6') }}</p>
                    <p>{{ $t('message.privacy-7') }}</p>

                    <div class="mt-4 mb-3">
                        <p><strong>{{ $t('message.privacy-8') }}</strong></p>
                        <ul>
                            <li class="mb-1">{{ $t('message.privacy-9') }}</li>
                            <li class="mb-1">{{ $t('message.privacy-10') }}</li>
                            <li class="mb-1">{{ $t('message.privacy-11') }}</li>
                            <li class="mb-1">{{ $t('message.privacy-12') }}</li>
                            <li class="mb-1">{{ $t('message.privacy-13') }}</li>
                            <li class="mb-1">{{ $t('message.privacy-14') }}</li>
                        </ul>
                    </div>

                    <p>{{ $t('message.privacy-15') }}
                        <a href='https://matomo.org/matomo-cloud-privacy-policy/' target="_blank">Matomo Cloud sine retningslinjer for personvern</a>.
                        {{ $t('message.privacy-16') }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Language from "./Language.vue";
export default {
    name: "PrivacyStatementComponent",
    data() {
        return {
            languageCodeList:[
                {lang:'eng',langISOCode:'en'},
                {lang:'nny',langISOCode:'nn'},
                {lang:'nbo',langISOCode:'nb'}
            ]
        }
    },
    computed: {
        selectedLanguageCode () {
            return this.languageCodeList.find(x=>x.lang==localStorage.getItem('lang')).langISOCode;
        },
    },
    components: {
        Language
    },
    created() {
        $("body,html").animate(
            {
                scrollTop: 0
            },
            60
        );
    }
};
</script>


